module.exports = __webpack_public_path__ + "static/media/feb 2021.56758fbb.svg";